import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from './../../../../core/toast.service';
import { FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GetDentalSuppliersService } from '../../services/get-dental-suppliers.service';
import { AddSupplierAccountService } from '../../services/add-supplier-account.service';

@Component({
  selector: 'app-add-account-pay',
  templateUrl: './add-account-pay.component.html',
  styleUrls: ['./add-account-pay.component.scss']
})
export class AddAccountPayComponent implements OnInit {
  /* --------------------------------- FIELDS -------------------------------- */
  dentalSupplierList: any[];
  accountPayForm =  this._fb.group ({
    supplier_id: [null, Validators.required],
    account_number: [null, Validators.required]
  });
  /* ------------------------------- CONSTRUCTOR ------------------------------ */
  constructor(
    private _dialogRef: MatDialogRef<AddAccountPayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: null,
    private _fb: FormBuilder,
    private addSupplierAccountService : AddSupplierAccountService,
    private toast: ToastService,
    private spinner: NgxSpinnerService
  ) { }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit() {
    this.addSupplierAccountService.getRemainingSuppliers().subscribe(dentalSupplierList=>{
      this.dentalSupplierList = dentalSupplierList;
    })
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  closeDialog(status: string) {
    // this._dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }
  /* --------------------------------- GETTERS --------------------------------- */
  get supplier_id() {
    return this.accountPayForm.get('supplier_id')
  }
  get account_number() {
    return this.accountPayForm.get('account_number')
  }

  /* --------------------------- Add Update Account --------------------------- */
  async addUpdateSupplierAccount(){
    if(this.accountPayForm.invalid){
      this.toast.openSnackBar('Please enter valid details');
      this.accountPayForm.markAllAsTouched();
      return;
    }
    this.spinner.show();
    try{
      const supplierAccount = this.accountPayForm.value as any;
      await this.addSupplierAccountService.addSupplierAccount(supplierAccount);
      this.spinner.hide();
      this.toast.openSnackBar('Account details saved successfully');
      this.closeDialog('yes');
    } catch(error) {
      this.spinner.hide();
      this.toast.openSnackBar('Unable to save account details');
    }
  }

  trimMe(ac: AbstractControl){
    ac.setValue(ac.value.trim());
  }

  onlyNumbers(ev: KeyboardEvent){
    console.log(ev);
    return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9','Backspace','ArrowLeft', 'ArrowRight'].includes(ev.key);
  }

}
